import React, { useState } from 'react';
import { ReactComponent as ShareIcon } from './../../assets/images/icons/share.svg';
import styles from './ProfileShare.module.css';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

const classNames = require('classnames');

/**
 * Component for sharing the Space Profile
 */
export default function ProfileShare({ profile, theme }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const [showModal, setShowModal] = useState(false);

  const handleShareClick = () => {
    const url = `${window.location.origin.toString()}/profile/${profile.guid}`;
    if (navigator.share) {
      navigator.share({
        title: `ID360 - Space Profile - ${profile.property} - Unit ${profile.address2}`,
        text: `ID360 - Space Profile - ${profile.property} - Unit ${profile.address2}`,
        url
      }).catch(console.error('An error ocurred.'));
    } else {
      const body = intl.formatMessage({id: 'ProfileShare.body'}, {url});
      window.open(`mailto:?subject=${intl.formatMessage({id: 'ProfileShare.subject'}, {property: profile.property, address2: profile.address2})}&body=${body}`);
    }
  }

  return (
    <>
      <div onClick={handleShareClick} style={{ color: theme.headerIconColor }} className={classNames(styles.shareSec, 'd-flex align-items-center justify-content-between')}>
        <ShareIcon style={{ fill: theme.headerIconColor, marginRight: '4px' }} /> {t('ProfileShare.share')}
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className={styles.isAdminModalHeader}>
          <Modal.Title className={styles.isAdminModalHeaderTitle}>{t('ProfileShare.shareProfile')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles['isAdminModalBody']}>
          {t('ProfileShare.share')}
        </Modal.Body>
        <Modal.Footer className={styles.isAdminModalFooter}>
          <Button variant="secondary" onClick={() => setShowModal(false)} className='btn-gray'>
            {t('ui.close')}
          </Button>
          <Button variant="primary" onClick={() => { }} className='btn-prime'>
            {t('ProfileShare.share')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
